<template>
  <b-modal :ref="modalRef" :id="modalId" :title="title" hide-footer>
    <div>
      <p>
        <span style="font-weight: 500">Họ tên nhân viên:</span>
        {{ formData?.employeeName }}
        {{ formData?.employeeCode ? `(${formData?.employeeCode})` : '' }}
      </p>
      <p>
        <span style="font-weight: 500">Cửa hàng hiện tại:</span>
        {{ formData?.currentStoreName }}
      </p>
      <p>
        <span style="font-weight: 500">Cửa hàng yêu cầu chuyển đến:</span>
        {{ formData?.targetStoreName }}
      </p>
    </div>
    <div class="d-flex justify-content-start">
      <b-button @click="handleCancel" variant="primary" size="sm"
        >Quay lại</b-button
      >
      <b-button
        @click="handleConfirm"
        :variant="confirmButtonVariant"
        class="ml-3"
        size="sm"
        >{{ confirmButtonText }}</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TransferStoreFormActionModal',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      default: null,
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    confirmButtonVariant: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    modalRef() {
      return this.modalId.replace(/-/g, '_');
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    show() {
      this.$bvModal.show(this.modalId);
    },
    hide() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
